import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { authClient } from '@/lib/auth'
import { requireAuth } from '@/lib/middleware'
import { OnboardingPipelinePage } from '@/features/onboarding-management/pipeline'

export const Route = createFileRoute(
  '/_authenticated/_organization/onboarding/management/pipeline'
)({
  beforeLoad: async () => {
    await requireAuth()
  },
  component: OnboardingPipelineRoute,
})

function OnboardingPipelineRoute() {
  const navigate = useNavigate()
  const { data: activeMember } = authClient.useActiveMember()
  const memberRole = activeMember?.role

  // Restrict to admin/owner/coordinator/team_leader roles
  if (
    memberRole &&
    memberRole !== 'owner' &&
    memberRole !== 'admin' &&
    memberRole !== 'support_coordinator'
  ) {
    navigate({ to: '/' })
    return null
  }

  return <OnboardingPipelinePage />
}
